import Vue from "vue";
import Vuex, { Payload } from "vuex";
import VuexPersistence from "vuex-persist";
import businessPlan from "@/store/businessPlan";
import authModule from "@/store/auth";
import attributeModule from "@/store/attribute";
import catalogModule from "@/store/catalog";
import itemModule from "@/store/item";
import accessrule from "@/store/accessrule";
import partnerModule from "@/store/partner";
import portfolioModule from "@/store/portfolio";
import contactUsEnquiryModule from "@/store/contactUsEnquiry";
import roleModule from "@/store/role";
import permissionModule from "@/store/permission";
import tenantModule from "@/store/tenant";
import faqModule from "@/store/faq";
import servicerequestModule from "@/store/servicerequest";
import orderModule from "@/store/order";
import notificationModule from "@/store/notification";
import advertisementModule from "@/store/advertisement";
import inventoryModule from "@/store/inventory";
import passwordResetModule from "@/store/passwordReset";
import taxcodeModule from "@/store/taxcode";
import couponModule from "@/store/coupon";
import customerModule from "@/store/customer";
import profileUpdateModule from "@/store/profileUpdate";
import subscriptionPlanModule from "@/store/subscriptionplan";
import deliveryModule from "@/store/delivery";
import invoiceModule from "@/store/invoice";
import subscriptionModule from "@/store/subscriptions";
import walletstatementModule from "@/store/walletStatement";
import serviceTicketModule from "@/store/serviceticket";
import commissionModule from "@/store/commission";
import paymentModule from "@/store/partnerpayment";
import customerManagement from "@/store/customerManagement";
import tenantProfile from "@/store/tenantProfile";
import emailTemplateModule from "@/store/emailtemplate";
import smsTemplateModule from "@/store/smstemplate";
import whatsappTemplateModule from "@/store/whatsapptemplate";
import inappTemplateModule from "@/store/inapptemplate";
import bulkNotificationModule from "@/store/bulkNotification";
import approvalNotificationBulkModule from "@/store/approvalNotificationBulk";
import featureModule from "@/store/feature";
import Resources from "@/store/currency";
import concern from "@/store/concern";
import profile from "@/store/profile";
import privacySetting from "@/store/privacySetting";
import unit from "@/store/unit";
import onboardCustomer from "@/store/onboardCustomer";
import survey from "@/store/survey";
import returnPolicy from "@/store/returnPolicy";
import fraudManagement from "@/store/fraudManagement";
import blogModule from "@/store/blog";
import Channel from "@/store/channel";
import ticketManagementModule from "@/store/ticketManagement";
Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  modules: [
    "partner",
    "portfolio",
    "contactUsEnquiry",
    "item",
    "subscription",
    "walletstatement",
    "serviceticket",
    "invoice",
    "advertisement",
  ],
  key: "nipige-state",
});

export const store = new Vuex.Store({
  plugins: [vuexLocal.plugin],
  modules: {
    attribute: attributeModule,
    catalog: catalogModule,
    item: itemModule,
    partner: partnerModule,
    portfolio: portfolioModule,
    contactUsEnquiry: contactUsEnquiryModule,
    role: roleModule,
    permission: permissionModule,
    tenant: tenantModule,
    faq: faqModule,
    delivery: deliveryModule,
    servicerequest: servicerequestModule,
    auth: authModule,
    order: orderModule,
    notification: notificationModule,
    inventory: inventoryModule,
    passwordReset: passwordResetModule,
    taxcode: taxcodeModule,
    coupon: couponModule,
    customer: customerModule,
    profileUpdate: profileUpdateModule,
    subscriptionplan: subscriptionPlanModule,
    invoice: invoiceModule,
    subscription: subscriptionModule,
    walletstatement: walletstatementModule,
    serviceticket: serviceTicketModule,
    commission: commissionModule,
    payment: paymentModule,
    tenantProfile,
    currency: Resources,
    concern: concern,
    customerManagement: customerManagement,
    emailTemplate: emailTemplateModule,
    smsTemplate: smsTemplateModule,
    whatsappTemplate: whatsappTemplateModule,
    inappTemplate: inappTemplateModule,
    bulkNotification: bulkNotificationModule,
    approvalNotificationBulk: approvalNotificationBulkModule,
    feature: featureModule,
    businessPlan,
    profile,
    accessrule,
    advertisement: advertisementModule,
    privacySetting,
    unit,
    onboardCustomer,
    survey,
    returnPolicy,
    fraudManagement,
    blog: blogModule,
    channel: Channel,
    ticketManagement: ticketManagementModule,
  },
});
